import classNames from 'classnames';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

import { daysOfWeek } from './utils';
import { getScheduleStudents } from '../../Common/Database';
import { throwErrorRollbar } from '../../index';

const CronParser = require('cron-parser');

import './style.scss';

const Schedule = ({ mail }) => {
  const { t } = useTranslation();
  const [schedules, setSchedules] = useState([]);
  const [tooltipClasses, setTooltipClasses] = useState({});
  const hours = Array.from({ length: 13 }, (_, index) => index + 8);

  const tooltipePosition = schedule => {
    const start = new Date(schedule.start);
    const top = (start.getHours() + start.getMinutes() / 60 - 8) * 7.72 - 0.1;

    const tooltipId = schedule.id;

    if (top > 80) {
      setTooltipClasses(prev => ({ ...prev, [tooltipId]: true }));
    }
  };

  const fetchStudentSchedule = async () => {
    try {
      const response = await getScheduleStudents(mail);
      const resp = response.val();
      let stSchedule = Object.values(resp);
      const outputArray = [];

      for (const key1 in stSchedule) {
        const innerObj = stSchedule[key1];
        for (const key2 in innerObj) {
          const schedule = innerObj[key2];
          const cron = CronParser.parseExpression(schedule.cron);
          const date = new Date();
          const duration = parseInt(schedule.duration);
          const options = { weekday: 'long' };

          for (let i = 0; i < 7; i++) {
            const nextFire = cron.next().toDate();
            const dayOfWeek = new Intl.DateTimeFormat('en-US', options).format(nextFire).toLowerCase();
            const startTime = nextFire.getTime();
            let endTime = startTime + duration * 60000;
            const maxEndTime = new Date(nextFire);
            maxEndTime.setHours(21, 0, 0, 0);
            endTime = Math.min(endTime, maxEndTime.getTime());

            const formatTime = time => {
              const hours = time.getHours();
              const minutes = time.getMinutes();
              return `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
            };

            if (nextFire >= date) {
              const entry = {
                start: nextFire,
                duration,
                id: schedule.id,
                quartz: schedule.cron,
                subject: schedule.subject,
                teacher: schedule.teacher,
                dayOfWeek,
                intervalStart: formatTime(new Date(startTime)),
                intervalEnd: formatTime(new Date(endTime)),
              };

              outputArray.push(entry);
              tooltipePosition(entry);
            }
          }
        }
      }

      setSchedules(outputArray);
    } catch (error) {
      console.error('error', error);
      throwErrorRollbar(error);
    }
  };

  useEffect(() => {
    fetchStudentSchedule();
  }, []);

  const getEntryStyle = schedule => {
    const start = new Date(schedule.start);
    const height = (schedule.duration / 60) * 7.6 + 0.3;
    const top = (start.getHours() + start.getMinutes() / 60 - 8) * 7.715 - 0.1;

    return {
      height: `${height > 0 ? height : 0}%`,
      top: `${top > 0 ? top : 0}%`,
    };
  };

  return (
    <div className="schedule-page container">
      <div className="title-wrap">
        <h1>{t('schedule')}</h1>
      </div>

      <div className="scroll-wrap">
        <ul className="schedule-list">
          {daysOfWeek.map(dayOfWeek => (
            <li className={`${dayOfWeek.day} schedule-item`} key={dayOfWeek.id}>
              <div className="day-label">{t(dayOfWeek.day)}</div>
              <div id={dayOfWeek.id} className="schedule">
                {hours.map(hour => (
                  <div className={`schedule-block time-${hour}`} key={hour}>
                    {dayOfWeek.day === 'monday' && <div className="block-time">{hour}:00</div>}
                  </div>
                ))}

                {schedules
                  .filter(el => el.dayOfWeek === dayOfWeek.day)
                  .map((el, index) => {
                    return (
                      <Link
                        className={`schedule-entry tooltipe-wrap ${el.subject}`}
                        key={uuidv4()}
                        style={getEntryStyle(el)}
                        to={`/subject/${mail}/${el.subject}`}
                      >
                        <div>{t(el.subject)}</div>
                        <div
                          className={classNames('tooltipe-schedule', {
                            bottom: !tooltipClasses[el.id],
                          })}
                        >
                          <span className="name">{el.teacher}</span>
                          <span className="time">
                            {el.intervalStart} - {el.intervalEnd}
                          </span>
                        </div>
                      </Link>
                    );
                  })}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Schedule;
